"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ClickAwayListener_1 = require("@material-ui/core/ClickAwayListener");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var tooltipStyles_1 = require("./tooltipStyles");
var ClickableTooltip = function (_a) {
    var children = _a.children, _b = _a.IconType, IconType = _b === void 0 ? icons_1.InfoOutlined : _b, _c = _a.placement, placement = _c === void 0 ? 'right' : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var styles = tooltipStyles_1.default();
    var _e = react_1.useState(false), tooltipOpen = _e[0], setTooltipOpen = _e[1];
    var openTooltip = react_1.useCallback(function (e) {
        e.stopPropagation();
        setTooltipOpen(true);
    }, []);
    return (<core_1.Box component="span" className={className}>
      <ClickAwayListener_1.default onClickAway={function () { return setTooltipOpen(false); }}>
        <core_1.Tooltip arrow={false} placement={placement} title={children} id="summaryTooltip" interactive={true} open={tooltipOpen} classes={{
        tooltip: styles.tooltipContainer,
        arrow: styles.tooltipArrow,
    }}>
          <core_1.IconButton onClick={openTooltip} data-test="common:mui:tooltip" className={styles.tooltipIconButton} disableRipple={true}>
            <IconType color="primary" viewBox="0 0 28 28" fontSize="default" classes={{
        root: styles.tooltipSvg,
    }}/>
          </core_1.IconButton>
        </core_1.Tooltip>
      </ClickAwayListener_1.default>
    </core_1.Box>);
};
exports.default = ClickableTooltip;
